import { useState } from "react";
import { X, MessageSquareWarning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api } from "../api";
import { getRecentErrors } from "../lib/errorLog";
import { useToast } from "./Toast.jsx";

export default function FeedbackModal({ page, onClose }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const { showToast, ToastElement } = useToast();

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setSending(true);
    setError("");
    try {
      await api.submitFeedback({
        message: message.trim(),
        page,
        appVersion: __APP_VERSION__,
        userAgent: navigator.userAgent,
        isElectron: /Electron/.test(navigator.userAgent),
        screenSize: `${window.innerWidth}x${window.innerHeight}`,
        recentErrors: getRecentErrors(),
      });
      showToast("Спасибо, отправлено");
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || "Не удалось отправить, попробуйте ещё раз");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[300] flex items-center justify-center p-4"
      onMouseDown={e => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full overflow-hidden flex flex-col" style={{ maxWidth: 480 }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 flex-shrink-0">
          <span className="flex items-center gap-2 text-base font-bold text-slate-900">
            <MessageSquareWarning className="h-4 w-4 text-amber-500" />
            Сообщить о проблеме
          </span>
          <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="px-5 py-4 flex flex-col gap-3">
          <p className="text-xs text-slate-400">
            Опишите подробно — что делали, что ожидали, что произошло. Версия приложения и техническая информация приложатся автоматически.
          </p>
          <Textarea
            autoFocus
            rows={6}
            placeholder="Например: открыл скан на редактирование, нажал «Сохранить», ничего не произошло..."
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          {error && <p className="text-xs text-red-600">{error}</p>}
          <Button disabled={sending || !message.trim()} onClick={handleSubmit} className="w-full">
            {sending ? "Отправка..." : "Отправить"}
          </Button>
        </div>
      </div>
      <ToastElement />
    </div>
  );
}
